<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>{{ $t('accountingDocument') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isMobile && !id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="create"
          >
            <v-icon
              color="green"
              style="font-size: 22px"
            >
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('submit') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isMobile && id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="update"
          >
            <v-icon
              color="green"
              style="font-size: 22px"
            >
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('submit') }}</span>
      </v-tooltip>
      <v-tooltip
        v-if="selected.length > 0"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="deletDialog = true"
          >
            <v-icon
              color="pink"
              style="font-size: 22px"
            >
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('remove') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showSelect = !showSelect"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              {{ (showSelect ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked-outline') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('select-row') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( 'accountingList' )"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('accountingList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-form
      v-if="render"
      id="app"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-tabs>
        <v-tab style="height: 50px">
          {{ $t('public-information') }}
        </v-tab>
        <v-tab
          :disabled="documentPermmission"
        >
          {{ $t('documents') }}
        </v-tab>
        <v-tab-item>
          <v-row class="mx-0 my-2">
            <v-col
              cols="12"
              md="6"
              sm="6"
              class="mb-0  "
            >
              <v-text-field
                v-model="content"
                height="20"
                :label="$t('documentContent')"
                dense
                outlined
                clearable
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="3"
              class="mb-0  "
            >
              <v-select
                v-model="type"
                :label="$t('documentType')"
                :items="typeItems"
                height="30"
                dense
                outlined
                item-value="value"
                item-text="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="3"
            >
              <template>
                <v-text-field
                  id="from"
                  v-model="date"
                  :label="$t('date')"
                  :rules="[v => !!v || $t('is-required')]"
                  clear-icon="flaticon2-close-cross"
                  outlined
                  dense
                  clearable
                />

                <date-picker
                  v-model="date"
                  element="from"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :min="$store.state.startDate"
                  :max="$store.state.endDate"
                  :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </template>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              md="2"
            >
              <v-text-field
                v-model="number"
                height="20"
                dense
                :rules="[v => !!v || $t('is-required')]"
                outlined
                clearable
                :label="$t('number')"
                @blur="getDocumentNumber"
              />
            </v-col>
            <v-col
              cols="12"
              sm="2"
              md="2"
            >
              <v-text-field
                v-model="turningNumber"
                height="20"
                dense
                :rules="[v => !!v || $t('is-required')]"
                outlined
                clearable
                :label="$t('turningNumber')"
                disabled
              />
            </v-col>
            <v-col
              cols="12"
              sm="2"
              md="2"
            >
              <v-text-field
                v-model="dailyNumber"
                height="20"
                dense
                :rules="[v => !!v || $t('is-required')]"
                outlined
                clearable
                :label="$t('dailyNumber')"
                disabled
              />
            </v-col>
            <v-col
              class="mb-0 pb-0 "
              cols="12"
              md="3"
              sm="3"
              style="height: 55px"
            >
              <status
                v-model="status"
                :hideconfig="true"
                :type="type"
                :value="status"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <aicomplete
                v-model="branch"
                title="branch"
                type="branch"
                :set-init="true"
                :val="branch"
                :new-btn="true"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <tag
                v-model="tag"
                :solo="false"
                :input="tag"
                :height="25"
              />
            </v-col>
          </v-row>
          <v-col
            cols="12"
            class="px-2 py-0 border-datatable"
            style="zoom: 0.85"
          >
            <v-data-table
              v-if="headers"
              ref="table"
              v-model="selected"
              v-sortable-data-table
              :headers="headers"
              :items="items"
              :options.sync="tableOptions"
              :server-items-length="totalItems"
              :loading="loading"
              multi-sort
              dense
              :height="tableHeight"
              fixed-header
              :show-select="showSelect"
              hide-default-footer
              item-key="i"
              @sorted="saveOrder"
            >
              <template v-slot:item.row="{ item }">
                <div class="d-flex align-center">
                  <v-menu
                    offset-y
                  >
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn
                        color="primary"
                        v-bind="attrs"
                        icon
                        small
                        class="my-2"
                        v-on="on"
                      >
                        <v-icon>
                          mdi-dots-vertical
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item
                        link
                        @click="addRow(item)"
                      >
                        <v-list-item-icon>
                          <v-icon color="primary">
                            mdi-content-copy
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$t('copy')" />
                      </v-list-item>
                      <v-list-item
                        link
                        @click="reverse(item)"
                      >
                        <v-list-item-icon>
                          <v-icon color="primary">
                            mdi-repeat-variant
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$t('reverseRow')" />
                      </v-list-item>
                      <v-list-item
                        link
                        @click="openDeleteDialog(item)"
                      >
                        <v-list-item-icon>
                          <v-icon color="pink">
                            mdi-trash-can-outline
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="$t('remove')" />
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  {{ parseInt(items.indexOf(item))+ parseInt(from) }}
                </div>
              </template>
              <template v-slot:item.content="{ item }">
                <v-text-field
                  v-model="item.content"
                  height="20"
                  dense
                  solo
                  flat
                  class="mb-3 dense"
                  :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                  clearable
                  :placeholder="$t('content')"
                />
              </template>
              <template v-slot:item.tracking_number="{ item }">
                <v-text-field
                  v-model="item.tracking_number"
                  height="20"
                  dense
                  solo
                  flat
                  :disabled="(item.given && item.given.tracking ? false : true)"
                  class="mb-3 dense"
                  :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                  clearable
                  :placeholder="$t('issueTracking')"
                />
              </template>
              <template v-slot:item.given="{ item }">
                <autocomplete
                  :ref="'refProduct' + parseInt(items.indexOf(item))"
                  v-model="item.given"
                  class="mb-3"
                  :new-btn="true"
                  :rules="[v => !!v || $t('is-required')]"
                  type="given"
                  :value="item.given"
                />
              </template>
              <template v-slot:item.fin4="{ item }">
                <autocomplete
                  :ref="'refFin4' + parseInt(items.indexOf(item))"
                  v-model="item.fin4"
                  class="mb-3"
                  :new-btn="true"
                  type="detail"
                  :value="item.fin4"
                  @input="checkProduct(item.product, parseInt(items.indexOf(item)))"
                />
              </template>
              <template v-slot:item.fin5="{ item }">
                <autocomplete
                  :ref="'refFin5' + parseInt(items.indexOf(item))"
                  v-model="item.fin5"
                  class="mb-3"
                  :new-btn="true"
                  type="detail"
                  :value="item.fin5"
                  @input="checkProduct(item.product, parseInt(items.indexOf(item)))"
                />
              </template>
              <template v-slot:item.fin6="{ item }">
                <autocomplete
                  :ref="'refFin6' + parseInt(items.indexOf(item))"
                  v-model="item.fin6"
                  class="mb-3"
                  :new-btn="true"
                  type="detail"
                  :value="item.fin6"
                  @input="checkProduct(item.product, parseInt(items.indexOf(item)))"
                />
              </template>
              <template v-slot:item.count="{ item }">
                <v-text-field
                  v-model="item.count"
                  height="20"
                  dense
                  solo
                  flat
                  class="mb-3 dense"
                  clearable
                  :disabled="(item.given && item.given.some ? false : true)"
                  :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                  :placeholder="$t('count')"
                  type="number"
                  @input="checkCount(item)"
                />
              </template>
              <template v-slot:item.debtor="{ item }">
                <money
                  v-model="item.debtor"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  class="mb-3 dense"
                />
              </template>
              <template v-slot:item.creditor="{ item }">
                <money
                  v-model="item.creditor"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  class="mb-3 dense"
                />
              </template>
              <template v-slot:item.currency_amount="{ item }">
                <money
                  v-model="item.currency_amount"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :disabled="(item.given && item.given.currencyFeature ? false : true)"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="currencyOptions"
                  class="mb-3 dense"
                />
              </template>
              <template v-slot:item.currency="{ item }">
                <autocomplete
                  v-model="item.currency"
                  class="mb-3"
                  type="currency"
                  :disabled="(item.given && item.given.currencyFeature ? false : true)"
                  :value="item.currency"
                />
              </template>
              <template
                v-slot:footer
              >
                <v-row>
                  <v-col
                    cols="12"
                    class="mb-0"
                  >
                    <v-simple-table
                      class="summary-footer"
                      dense
                    >
                      <template v-slot:default>
                        <tbody>
                        <tr>
                          <td
                            style="width:66%;border-top : 1px solid #e3e3e3 !important;"
                          >
                            <div class="d-flex justify-start">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-shortkey="['f2']"
                                    v-bind="attrs"
                                    icon
                                    small
                                    class="float-left"
                                    @shortkey="addRow()"
                                    v-on="on"
                                    @click="addRow()"
                                  >
                                    <v-icon
                                      color="teal"
                                      style="font-size: 22px"
                                    >
                                      mdi-plus-box-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t('newRow') }} (f2)</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    icon
                                    small
                                    class="float-left"
                                    :disabled="(selected.length > 0 ? false : true)"
                                    v-on="on"
                                    @click="openDeleteDialogVerify()"
                                  >
                                    <v-icon
                                      color="pink"
                                      style="font-size: 22px"
                                    >
                                      mdi-trash-can-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t('remove') }} (f2)</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    icon
                                    small
                                    class="float-left"
                                    :disabled="(selected.length > 0 ? false : true)"
                                    v-on="on"
                                    @click="copyRow"
                                  >
                                    <v-icon
                                      color="blue"
                                      style="font-size: 22px"
                                    >
                                      mdi-content-copy
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t('copy') }}</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    icon
                                    small
                                    class="float-left"
                                    :disabled="(selected.length > 0 ? false : true)"
                                    v-on="on"
                                    @click="reverseRow"
                                  >
                                    <v-icon
                                      color="blue"
                                      style="font-size: 22px"
                                    >
                                      mdi-repeat-variant
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t('reverseRow') }}</span>
                              </v-tooltip>
                            </div>
                          </td>
                          <td style="border-top : 1px solid #e3e3e3 !important;" />
                          <td style="border-top : 1px solid #e3e3e3 !important;background: aliceblue;">
                            {{ $t('debtor') }}
                          </td>
                          <td style="border-top : 1px solid #e3e3e3 !important;background: antiquewhite;">
                            {{ $t('creditor') }}
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" />
                          <td>{{ $t('sum') }}</td>
                          <td>{{ $numberFormat(totals.debtor) }}</td>
                          <td>{{ $numberFormat(totals.creditor) }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('remain') }}</td>
                          <td>{{ $numberFormat((+totals.debtor - +totals.creditor > 0 ? +totals.debtor - +totals.creditor : 0)) }}</td>
                          <td>{{ $numberFormat((+totals.creditor - +totals.debtor > 0 ? +totals.creditor - +totals.debtor : 0)) }}</td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 pt-2">
            <v-col
              cols="12"
              md="3"
              sm="3"
            >
              <file-picker
                ref="refFilePicker"
                v-model="attachments"
                :label="$t('addDocuments')"
                :multiple="true"
                type-prop="accounting"
                :val="(id && attachments ? attachments : null)"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-card-actions class="pt-0">
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-0"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
          </v-col>
        </v-row>
      </v-card-actions>
      <v-row />
    </v-form>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="alertDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="alertDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ alertText }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                @click="draftStore"
              >
                {{ $t('submit') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="alertDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'blue')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import General from '../../../../Mixins/general'
  import autocomplete from '../../components/general/patial/autocomplete'
  import Sortable from 'sortablejs'
  import filePicker from '../../components/general/filePicker/index'
  function initialData () {
    return {
      selected: [],
      currencyOptions: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 10,
      },
      printDialog: false,
      attachments: null,
      deletDialog: false,
      alertDialog: false,
      alertText: null,
      showSelect: true,
      filter: false,
      render: true,
      valid: true,
      number: null,
      date: null,
      content: null,
      model: null,
      from: 1,
      taskDialog: null,
      id: null,
      status: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      turningNumber: null,
      dailyNumber: null,
      items: [],
      typeItems: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      type: 'general',
      taskId: null,
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      headers: null,
      draftStatus: false,
      search: null,
    }
  }
  export default {
    name: 'Document',
    components: {
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      filePicker,
      autocomplete,
      Task,
    },
    directives: {
      sortableDataTable: {
        bind (el, binding, vnode) {
          const options = {
            animation: 0,
            // onUpdate: function (event) {
            //   vnode.child.$emit('sorted', event)
            // },
          }
          Sortable.create(el.getElementsByTagName('tbody')[0], options)
        },
      },
    },
    mixins: [General],
    props: ['input', 'formType', 'refId', 'itemsProp'],
    data: function () {
      return initialData()
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      totals: function () {
        const totals = this.items.reduce((acc, d) => {
          acc.debtor += (d.debtor ? parseFloat(d.debtor) : 0)
          acc.creditor += (d.creditor ? parseFloat(d.creditor) : 0)
          return acc
        }, {
          debtor: 0,
          creditor: 0,
        })
        return totals
      },
    },
    activated: function () {
      if (this.id) {
        this.show()
      }
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          if (app.tableOptions.sortBy) {
            app.tableOptions.sortBy.map(function (value, key) {
              const index = app.headers.findIndex(h => h.value === value)
              app.sortBy.push(app.headers[index].table)
            })
          }
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      id (val) {
        Object.assign(this.$data, initialData())
        this.$refs.form.resetValidation()
        this.initialMounted()
        if (val) {
          this.show()
        }
      },
      items: {
        handler () {
          this.items.map(function (item, index) {
            item.i = index
          })
        },
        deep: true,
      },
      itemsProp (val) {
        if (val) {
          this.items = val
        } else {
          this.items = []
          this.addRow()
        }
      },
    },
    mounted () {
      this.initialMounted()
    },
    methods: {
      initialMounted () {
        this.headers = [
          {
            text: this.$t('row'),
            align: 'start',
            sortable: false,
            value: 'row',
            width: 50,
          },
          {
            text: this.$t('given'),
            sortable: false,
            value: 'given',
            width: 200,
          },
          {
            text: this.$t('fin4'),
            sortable: false,
            value: 'fin4',
            width: 190,
          },
          {
            text: this.$t('fin5'),
            sortable: false,
            value: 'fin5',
            width: 190,
          },
          {
            text: this.$t('fin6'),
            sortable: false,
            value: 'fin6',
            width: 190,
          },
          {
            text: this.$t('content'),
            sortable: false,
            value: 'content',
            width: 280,
          },
          {
            text: this.$t('debtor'),
            sortable: false,
            value: 'debtor',
            width: 200,
          },
          {
            text: this.$t('creditor'),
            sortable: false,
            value: 'creditor',
            width: 200,
          },
          {
            text: this.$t('count'),
            sortable: false,
            value: 'count',
            width: 150,
          },
          {
            text: this.$t('issueTracking'),
            sortable: false,
            value: 'tracking_number',
            width: 230,
          },
          {
            text: this.$t('currency'),
            sortable: false,
            value: 'currency',
            width: 230,
          },
          {
            text: this.$t('currency-rate'),
            sortable: false,
            value: 'currency_amount',
            width: 230,
          },
        ]
        this.typeItems = [
          {
            value: 'initial',
            text: this.$t('initial'),
          },
          {
            value: 'general',
            text: this.$t('general'),
          },
          {
            value: 'draft',
            text: this.$t('draft'),
          },
          {
            value: 'closingAccount',
            text: this.$t('closingAccount'),
          },
          {
            value: 'closing',
            text: this.$t('closing'),
          },
        ]
        if (this.input) {
          this.model = this.input
        }
        this.loading = false
        if (this.itemsProp) {
          this.items = this.itemsProp
        } else {
          if (!this.id) {
            this.items = []
            this.addRow()
          }
        }
        if (this.$route.params.id != null) {
          // this.show()
          this.id = this.$route.params.id
        } else {
          this.getDocumentNumber()
          this.addRow()
        }
      },
      draftStore () {
        this.type = 'draft'
        this.alertDialog = false
        this.draftStatus = true
        if (this.id) {
          this.update()
        } else {
          this.create()
        }
      },
      getDocumentNumber () {
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              type: app.type,
              id: app.id,
              number: app.number,
              date: app.date,
              select: 'getDocumentNumber',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                app.snakbarText = res.message
                app.snakbarColor = 'pink'
                app.snakbar = true
                app.number = res.number
              }
              if (!app.id) {
                app.turningNumber = res.turning_number
                app.dailyNumber = res.daily_number
              }
              if (!app.number) {
                app.number = res.number
              }
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        // setTimeout(() => {
        //   app.$refs.autocomplete.onScroll()
        // }, 1500)
        this.loading = false
      },
      copyRow () {
        var app = this
        app.loading = true
        app.selected.map(function (value, key) {
          app.addRow(value)
        })
        app.loading = false
        app.selected = []
      },
      reverseRow () {
        var app = this
        app.loading = true
        app.selected.map(function (value, key) {
          app.reverse(value)
        })
        app.loading = false
        app.selected = []
      },
      reverse (item = null) {
        var debtor = item.debtor
        var creditor = item.creditor
        item.debtor = creditor
        item.creditor = debtor
      },
      addRow (item = null) {
        this.items.push({
          i: null,
          given: (item ? item.given : null),
          fin4: (item ? item.fin4 : null),
          fin5: (item ? item.fin5 : null),
          fin6: (item ? item.fin6 : null),
          count: (item ? item.count : null),
          debtor: (item ? item.debtor : null),
          creditor: (item ? item.creditor : null),
          content: (item ? item.content : null),
          tracking_number: (item ? item.tracking_number : null),
          currency_amount: (item ? item.currency_amount : null),
          currency: (item ? item.currency : null),
        })
      },
      remove (item, index) {
        var i = this.items.indexOf(this.deleteItem)
        this.items.splice(i, 1)
        this.deleteItem = null
        this.deletDialog = false
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openDeleteDialogVerify () {
        if (this.selected.length > 0) {
          this.deletDialog = true
        }
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'ProductEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'products', {
          params: {
            search: app.search,
            page: app.tableOptions.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      checkProduct (item, key) {
        if (item) {
          var index = this.items.findIndex(x => x.product.id === item.id)
          if (index !== key) {
            this.$refs['refProduct' + key].clear()
            this.snakbarText = this.$t('alert-product-is-repetitive')
            this.snakbarColor = 'pink'
            this.snakbar = true
          }
        }
      },
      checkCount (item) {
        if (this.$store.state.negative_inventory === 'no' && this.type === 'remittance' && parseFloat(item.count) > parseFloat(item.product.stock.count)) {
          this.snakbarText = this.$t('alert-inventory-is-not-enough')
          this.snakbarColor = 'pink'
          this.snakbar = true
          item.count = 0
        }
      },
      removegroup () {
        var app = this
        app.selected.map(function (value, key) {
          var i = app.items.indexOf(value)
          app.items.splice(i, 1)
        })
        app.deletDialog = false
        app.selected = []
      },
      create () {
        if (!this.$refs.form.validate()) return false
        if (this.totals && this.totals.debtor !== this.totals.creditor && !this.draftStatus) {
          this.alertText = this.$t('storeDraftDocument')
          this.alertDialog = true
          return false
        }
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'accounting', this.$data)
          .then(res => {
            res = res.data
            if (app.$refs.refFilePicker !== undefined && app.attachments) {
              app.$refs.refFilePicker.create(res.data.id)
            }
            app.snakbarText = app.$t('documentRegisterd')
            app.snakbarColor = 'green'
            app.snakbar = true
            Object.assign(this.$data, initialData())
            app.initialMounted()
            app.getDocumentNumber()
            app.$refs.form.resetValidation()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
            // this.clearForm()
            // this.addRow()
            // this.goTo('accountingList')
          })
      },
      update () {
        if (!this.$refs.form.validate()) return false
        if (this.totals && this.totals.debtor !== this.totals.creditor && !this.draftStatus) {
          this.alertText = this.$t('storeDraftDocument')
          this.alertDialog = true
          return false
        }
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'accounting/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            if (app.$refs.refFilePicker !== undefined) {
              app.$refs.refFilePicker.create(res.data.id)
            }
            app.$emit('close', app.$route)
            app.goTo('accountingList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accounting/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.id = res.id
            app.content = res.content
            app.attachments = res.attachments
            app.date = res.date
            app.number = res.number
            app.branch = res.branch
            app.turningNumber = res.turning_number
            app.dailyNumber = res.daily_number
            app.type = res.type
            app.status = (res.last_status ? res.last_status.status : null)
            app.items = res.article
            if (res.tags) {
              app.tag = res.tags
              app.more = true
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      clearForm () {
        this.selected = []
        this.attachments = null
        this.printDialog = false
        this.deletDialog = false
        this.alertDialog = false
        this.alertText = null
        this.draftStatus = false
        this.showSelect = false
        this.filter = false
        this.render = true
        this.valid = true
        this.number = null
        this.content = null
        this.model = null
        this.from = 1
        this.taskDialog = null
        this.id = null
        this.status = null
        this.tag = null
        this.temp = null
        this.deleteItem = null
        this.sellStatus = null
        this.turningNumber = null
        this.dailyNumber = null
        this.items = []
        this.dialog = null
        this.timer = 0
        this.totalItems = 1000
        this.isLoading = false
        this.snakbar = false
        this.type = 'general'
        this.taskId = null
        this.snakbarText = null
      },
      saveOrder (event) {
        const movedItem = this.items.splice(event.oldIndex, 1)[0]
        this.items.splice(event.newIndex, 0, movedItem)
      },
    },
  }
</script>
